'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var absoluteCenter = exports.absoluteCenter = function absoluteCenter() {
  var horizontal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return '\n' + (horizontal && 'left: 50%') + ';\nposition: absolute;\n' + (vertical && 'top: 50%') + ';\n' + (horizontal && !vertical ? 'transform: translateX(-50%)' : '') + '\n' + (!horizontal && vertical ? 'transform: translateY(-50%)' : '') + '\n' + (horizontal && vertical ? 'transform: translate(-50%, -50%)' : '');
};

var fadeIn = exports.fadeIn = function fadeIn() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.2s';
  return '\n@keyframes fadeIn {\n  0% {opacity: 0}\n  100% {transform: opacity: 1}\n}\nanimation-duration: ' + speed + ';\nanimation-iteration-count: 1;\nanimation-name: fadeIn';
};

var fontSmoothing = exports.fontSmoothing = function fontSmoothing() {
  var antiAliased = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return '\n-moz-osx-font-smoothing: ' + (antiAliased ? 'grayscale' : 'initial') + ';\n-webkit-font-smoothing: ' + (antiAliased ? 'antialiased' : 'initial');
};

var overlay = exports.overlay = function overlay() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'absolute';
  return '\nbottom: 0;\nleft: 0;\nposition: ' + position + ';\nright: 0;\ntop: 0';
};

var pseudoBlock = exports.pseudoBlock = function pseudoBlock() {
  return '\ncontent: \'\';\ndisplay: block';
};

var rgbaBlack = exports.rgbaBlack = function rgbaBlack() {
  var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .125;
  return '\nrgba(0, 0, 0, ' + opacity + ')';
};

var rgbaWhite = exports.rgbaWhite = function rgbaWhite() {
  var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .25;
  return '\nrgba(255, 255, 255, ' + opacity + ')';
};

var rotate = exports.rotate = function rotate(speed) {
  return '\n@keyframes rotate {\n  0% {transform: rotate(0deg)}\n  50% {transform: rotate(180deg)}\n  100% {transform: rotate(360deg)}\n}\nanimation-duration: ' + speed + ';\nanimation-iteration-count: infinite;\nanimation-name: rotate';
};